import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';

export function documentPackDocumentRevertApi(path: string) {
  return {
    path,
    DELETE: () => api.delete<JsonApiResponseSingle>(path),
  };
}
